import { axiosInstance } from "../axios-instance";

const option = "options";

const optionsServices = {
  getOptions: (itemId) => axiosInstance.get(`${option}/${itemId}`),
  getOption: (optionId) => axiosInstance.get(`${option}/show/${optionId}`),
  storeOption: (payload) => axiosInstance.postForm(`${option}/store`, payload),
  updateOption: (payload) =>
    axiosInstance.postForm(`${option}/update/${payload.id}`, payload),
  DeleteOption: (id) => axiosInstance.delete(`${option}/delete/${id}`),

  getOptionsItemsByCategoryID: (categoryId) =>
    axiosInstance.get(`product/getProductWithOption/${categoryId}`),
  getOptionsOfItemByID: (itemId) =>
    axiosInstance.get(`product/getProductWithOptionById/${itemId}`),

  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////subOption//////////////////////////////////////////

  getSubOptions: (optionId) => axiosInstance.get(`subOptions/${optionId}`),
  storeSubOption: (payload) =>
    axiosInstance.postForm(`sub/store`, payload),
  updateSubOption: (payload) =>
    axiosInstance.post(`subOptions/update/${payload.id}`, payload),
  DeleteSubOption: (id) => axiosInstance.delete(`subOptions/delete/${id}`),
};

export default optionsServices;
